export const FREKUENSI_OPTS = [
  { value: "HARIAN", label: "Harian" },
  { value: "MINGGUAN", label: "Mingguan" },
  { value: "BULANAN", label: "Bulanan" },
  { value: "DUA_BULANAN", label: "2 Bulanan" },
  { value: "TIGA_BULANAN", label: "3 Bulanan" },
  { value: "ENAM_BULANAN", label: "6 Bulanan" },
  { value: "TAHUNAN", label: "Tahunan" },
];

export const FREKUENSI_LABEL = FREKUENSI_OPTS.reduce((a, f) => ({ ...a, [f.value]: f.label }), {});

export const FREKUENSI_KET = {
  HARIAN: "tugas pengecekan muncul SETIAP HARI",
  MINGGUAN: "tugas muncul setiap 7 hari",
  BULANAN: "tugas muncul setiap 1 bulan",
  DUA_BULANAN: "tugas muncul setiap 2 bulan",
  TIGA_BULANAN: "tugas muncul setiap 3 bulan",
  ENAM_BULANAN: "tugas muncul setiap 6 bulan",
  TAHUNAN: "tugas muncul setiap 1 tahun",
};

export const fmtTgl = (s) => {
  const v = String(s || "").slice(0, 10);
  if (v.length === 10 && v[4] === "-") return `${v.slice(8, 10)}/${v.slice(5, 7)}/${v.slice(0, 4)}`;
  return v || "-";
};

export const errMsg = (err, fallback) => {
  const d = err?.response?.data?.detail;
  return typeof d === "string" ? d : fallback;
};

export const KAT_LABEL = { ENGINEERING: "Engineering", HOUSEKEEPING: "Housekeeping" };

export const KONDISI_OPTS = [
  { value: "NORMAL", label: "Normal" },
  { value: "ABNORMAL", label: "Abnormal" },
  { value: "PERLU_MAINTENANCE", label: "Perlu Maintenance" },
];
export const KONDISI_LABEL = KONDISI_OPTS.reduce((a, k) => ({ ...a, [k.value]: k.label }), {});

export const SATUAN_OPTS = ["°C", "%", "Bar", "RPM", "Volt", "Ampere", "Lainnya"];

// Kategori PM yang boleh diakses per peran (tab yang tampil)
export const pmCategories = (user) => {
  const role = user?.role;
  if (role === "approved_eng" || role === "petugas_eng") return ["ENGINEERING"];
  if (role === "approved_hk" || role === "petugas_hk") return ["HOUSEKEEPING"];
  return ["ENGINEERING", "HOUSEKEEPING"];
};
